import { useState, FC, KeyboardEvent } from 'react'
import { Dialog, DialogContent, DialogTitle, TextField, Button, DialogActions, Typography, Box } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { authActions } from '../../actions/AuthAction'
import { loginDialogStyle } from './LoginDialog.style'
import { RootState } from '../../Store'
import { FormattedMessage, useIntl } from 'react-intl'
export interface LoginDialogProps {
  open: boolean
}

export const LoginDialog: FC<LoginDialogProps> = (props: LoginDialogProps) => {
  const classes = loginDialogStyle()
  const dispatch = useDispatch()
  const intl = useIntl()

  const isLoggedIn = useSelector((state: RootState): boolean => state.authState.isLoggedIn)
  const loginInProgress = useSelector((state: RootState): boolean => state.authState.loginInProgress)
  const isError = useSelector((state: RootState): boolean => state.authState.isLoginError)
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')

  const submit = (): void => {
    dispatch(authActions.login({username: username, password: password}));
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter') {
      submit()
    }
  }

  return (
    <Dialog open={!isLoggedIn}>
      <DialogTitle className={classes.title}><FormattedMessage id='login.title' /></DialogTitle>
      <DialogContent>
        <Box className={classes.errorContainer}>
          {isError && (
            <Typography className={classes.errorText}><FormattedMessage id='login.error' /></Typography>
          )}
        </Box>
        <TextField
          required
          variant='standard'
          placeholder={intl.formatMessage({ id: 'login.username' })}
          onChange={event => setUsername(event.target.value)}
          onKeyPress={handleKeyPress}
          autoFocus
          value={username}
          error={isError}
          className={classes.username}
        />
        <TextField
          required
          variant='standard'
          placeholder={intl.formatMessage({ id: 'login.password' })}
          type='password'
          onChange={event => setPassword(event.target.value)}
          onKeyPress={handleKeyPress}
          value={password}
          error={isError}
          className={classes.password}
        />
      </DialogContent>
      <DialogActions className={classes.actionsContainer}>
        <Button
          disabled={loginInProgress}
          variant='contained'
          color='primary'
          onClick={submit}
        >
          <FormattedMessage id='login.submit' />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LoginDialog
